import { UnsupportedOperationError } from '@dialectlabs/sdk';
export class DialectSolanaWalletAdapterWrapper {
    constructor(delegate) {
        this.delegate = delegate;
    }
    get publicKey() {
        if (!this.delegate.publicKey) {
            throw new UnsupportedOperationError('Public key not available', 'Wallet does not have public key, please provide a valid public key.');
        }
        return this.delegate.publicKey;
    }
    get canEncrypt() {
        return Boolean(this.publicKey && this.delegate.diffieHellman);
    }
    static create(adapter) {
        return new DialectSolanaWalletAdapterWrapper(adapter);
    }
    signTransaction(transaction) {
        if (!this.delegate.signTransaction) {
            throw new UnsupportedOperationError('Signing not supported', 'Wallet does not support signing, please use wallet-adapter that supports signTransaction() operation.');
        }
        return this.delegate.signTransaction(transaction);
    }
    signAllTransactions(transaction) {
        if (!this.delegate.signAllTransactions) {
            throw new UnsupportedOperationError('Signing not supported', 'Wallet does not support signing, please use wallet-adapter that supports signAllTransactions() operation.');
        }
        return this.delegate.signAllTransactions(transaction);
    }
    signMessage(message) {
        if (!this.delegate.signMessage) {
            throw new UnsupportedOperationError('Message signing not supported', 'Wallet does not support message signing, please use wallet-adapter that supports signMessage() operation.');
        }
        return this.delegate.signMessage(message);
    }
    diffieHellman() {
        if (!this.delegate.diffieHellman) {
            throw new UnsupportedOperationError('Encryption not supported', 'Wallet does not support encryption, please use wallet-adapter that supports diffieHellman() operation.');
        }
        return this.delegate.diffieHellman(this.publicKey.toBytes());
    }
    canSignMessage() {
        return Boolean(this.delegate.signMessage);
    }
    canSignTransaction() {
        return Boolean(this.delegate.signTransaction);
    }
}
//# sourceMappingURL=dialect-solana-wallet-adapter-wrapper.js.map